import {
  FatoStateColor,
  FatoStateLabelColor,
  FatoTypeTrigram,
} from '@components/map/layers/vertiports/vertiport.constants';
import { ColorLabelEnum, hexColor } from '@utils/map/map.constants';

import { FatoStateEnum, FatoTypeEnum } from '@/types/intercom/intercom.types';

export function getFatoLabel(fatoType: FatoTypeEnum, fatoNumber: number): string {
  return `${FatoTypeTrigram[fatoType]}-${fatoNumber}`;
}

export function getFatoColor(fatoState: FatoStateEnum | null, label = true): ColorLabelEnum | string {
  if (!fatoState) {
    return label ? ColorLabelEnum.WHITE : hexColor.WHITE;
  }
  return label ? FatoStateLabelColor[fatoState] : FatoStateColor[fatoState];
}
